import { z } from 'zod'

import { Company } from '@/travelsuit'
import { CompanyZ } from '@/types/company'

import { getGGClient, RequestOverrides } from './GetGoingClient'

export async function getMyCompany(overrides?: RequestOverrides) {
	return getGGClient()
		.request('GET', `companies`, {
			responseSchema: CompanyZ,
			...overrides,
		})
		.then((r) => r.data as Company)
}

export async function getUnpaidFeesQuantity(countryPosId: number, overrides?: RequestOverrides) {
	return getGGClient()
		.request('GET', `companies/unpaid_fees`, {
			params: { country_pos: countryPosId },
			responseSchema: z.object({ unpaid_fees_count: z.number() }),
			...overrides,
		})
		.then((r) => r.data)
}
